import { FieldColorSelect } from "@animech/axiom-ui-builder";
import { useState } from "react";
import { InputProps } from "@animech/ui";
import { PropertyValue } from "src/common";
import { CheckBoxPropagateColor } from "src/ui/components/widgets";

export type ColorSelectWithColorPropagationFieldProps =
	InputProps<PropertyValue>;

export const ColorSelectWithColorPropagationField = ({
	...props
}: ColorSelectWithColorPropagationFieldProps) => {
	const { onValueChange, ...rest } = props;
	const [applyToAll, setApplyToAll] = useState<boolean>(false);

	const onColorValueChange = (newVal: unknown) => {
		onValueChange?.(newVal);
		if (applyToAll === true) {
			//applyActiveProductColorToAll();
		}
	};
	return (
		<>
			<FieldColorSelect onValueChange={onColorValueChange} {...rest} />
			<CheckBoxPropagateColor
				value={applyToAll}
				onValueChange={setApplyToAll}
			></CheckBoxPropagateColor>
		</>
	);
};
